module.exports = __webpack_public_path__ + "static/ch5-scrub-bloody_sunday_01-ab91a9493d710529ce1eeeb23ca46833.mp4";